export default {
    user(state) {
        return state.user;
    },

    userLogin(state) {
        return state.userLogin;
    },

    loggedIn(state) {
        return state.user && state.user.data;
    },

    selectedCompany(state) {
        return state.selectedCompany;
    },

    lang(state) {
        return state.settings.lang;
    },

    showMenu(state) {
        return state.showMenu;
    }
};